module.exports = __webpack_public_path__ + "static/media/xmr.c43edff2.svg";